var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.753 5.56274L19.2612 13.9999L27.753 22.437C27.9066 22.1162 27.9997 21.7615 27.9997 21.3827V6.61706C27.9997 6.23824 27.9066 5.8836 27.753 5.56274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5397 4.15625H2.46155C2.08273 4.15625 1.72808 4.24938 1.40723 4.40289L12.2607 15.2016C13.2203 16.1613 14.7809 16.1613 15.7405 15.2016L26.594 4.40289C26.2731 4.24938 25.9185 4.15625 25.5397 4.15625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.246641 5.56274C0.0931328 5.8836 0 6.23824 0 6.61706V21.3827C0 21.7615 0.0931328 22.1162 0.246641 22.437L8.73846 13.9999L0.246641 5.56274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1022 15.1597L16.9005 16.3613C15.3015 17.9603 12.6996 17.9603 11.1006 16.3613L9.89905 15.1597L1.40723 23.5968C1.72808 23.7503 2.08273 23.8434 2.46155 23.8434H25.5397C25.9185 23.8434 26.2731 23.7503 26.594 23.5968L18.1022 15.1597Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIcon);
export default __webpack_public_path__ + "static/media/Main_icon.b433f8ad4ca4381ba6e08c8ef58c822b.svg";
export { ForwardRef as ReactComponent };